import React from 'react'
import { t } from '@lingui/core/macro'
import FormSelect, { FormSelectItem } from './FormSelect'

const getRequisiteTypes = (): FormSelectItem[] => [
    { name: 'card', value: t`Карты` },
    { name: 'sbp', value: t`СБП` },
]

interface RequisiteTypeSelectProps {
    label: string
    value: string
    onChange: (value: string) => void
    errorMessage?: string
}

const RequisiteTypeSelect = ({ label, value, onChange, errorMessage }: RequisiteTypeSelectProps) => {
    return <FormSelect
        label={label}
        value={value}
        items={getRequisiteTypes()}
        placeholder={t`Любой тип реквизита`}
        searchPlaceholder={t`Поиск по типу реквизита`}
        onChange={onChange}
        errorMessage={errorMessage}
    />
}

export default RequisiteTypeSelect
